export default __webpack_public_path__ + "static/events-light-0d012c05f03a049c6c58e729d4017303.png";